export interface ICalendarInvite {
    iCal: boolean,
    startDate: string,
    startTime: string,
    endDate: string,
    endTime: string,
    requireRsvp: boolean
}